function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { boxShadow } from "../../utils/css/cssFor";
var buildStyle = function(theme, param) {
    var readingDirection = param.readingDirection;
    var backgroundColor = theme.backgroundColor, size = theme.size, depth = theme.depth;
    return {
        mainContainer: {
            base: {
                overflow: 'hidden',
                display: 'none',
                height: 0,
                opacity: 0
            },
            iePositioning: {
                position: 'relative'
            }
        },
        contentContainer: {
            base: {
                boxSizing: 'border-box',
                margin: 0,
                padding: theme.spacing[5]
            },
            noPadding: {
                padding: 0
            }
        },
        openContainer: {
            mainContainer: {
                base: {
                    display: 'block',
                    height: '100%',
                    opacity: 1
                }
            }
        },
        popoverContainer: {
            base: _objectSpread({
                borderRadius: size.border.radius.fiveX,
                backgroundColor: backgroundColor.base
            }, boxShadow(4, theme), {
                zIndex: depth.zIndex[100],
                overflowY: 'auto'
            }),
            overflowVisible: {
                overflow: 'visible'
            }
        },
        readingDirection: readingDirection
    };
};
var useStyle = function(isRtl, isOpen, nonAnimated, zIndex, hasPadding, overflowHidden) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {};
    }
    var mainContainer = builtStyle.mainContainer, contentContainer = builtStyle.contentContainer, openContainer = builtStyle.openContainer, popoverContainer = builtStyle.popoverContainer, readingDirection = builtStyle.readingDirection;
    return {
        mainContainer: _objectSpread({}, mainContainer.base, !isOpen && mainContainer.iePositioning, isOpen && openContainer.mainContainer.base),
        contentContainer: _objectSpread({}, contentContainer.base, !hasPadding && contentContainer.noPadding),
        popoverContainer: _objectSpread({}, popoverContainer.base, zIndex && {
            zIndex: zIndex
        }, readingDirection, !overflowHidden && popoverContainer.overflowVisible)
    };
};
export default useStyle;
